<template>
  <div id="main" ref="echart" style="width:100%;height:100%"></div>
</template>

<script>
  import {post} from "@/api/requrestHttp";
export default {
  components: {},
  data() {
    return {
      ck: true,
      openflower: {
        title: {
          // text: "模 拟 迁 徙",
          // subtext: "数据纯属虚构",
          left: "center",
          textStyle: {
            color: "#1935ff"
          }
        },
        amap: {
          maxPitch: 60,
          pitch: 10, //45 俯仰角
          viewMode: "3D",
          zoom: 5.5,
          expandZoomRange: true,
          zooms: [3, 20],
          mapStyle: "amap://styles/darkblue", //地图主题
          center: [116.841994,32.634171], //中心点
          rotation: 0, //顺时针旋转角度
          resizeEnable: true
        },
        animation: false,
        series: [],
        coordList:[]
      }
    };
  },
  created() {
    // this.creatarr();
  },
  mounted() {
    this.getEchartList();
    // setTimeout(() => {
    //   this.MapInfor();
    // }, 500);

  },
  methods: {
    getEchartList(){
      post("/admin/statistics/info/findZdOrg", {
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.coordList = res.content;
          this.MapInfor();
        } else {

        }
      });
    },
    initEchart() {
      // 获取DOM节点并初始化
      let chart = this.$echarts.init(this.$refs.echart);
      // 编写echart参数
      let option = {
        amap: {
          zoom: 10,
          zooms: [3, 20],
          mapStyle: "amap://styles/darkblue", // 地图主题
          center: [116.841994,32.634171], // 中心点
          lang: "en",
          resizeEnable: true
        },
        animation: false,
        series: [],
        tooltip: { return: "shanghai" }
      };
      // 设置图表的参数
      chart.setOption(option);
    },
    MapInfor(){
      var that = this;
      var planePath =
              "path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z";
      var myChart = this.$echarts.init(document.getElementById("main"));
      myChart.setOption({
        title: {
          left: "center",
          textStyle: {
            color: "#fff"
          }
        },
        amap: {
          zoom: 16,
          zooms: [3, 20],
          mapStyle: "amap://styles/darkblue", //地图主题
          // center: [116.841994,32.634171] //中心点
          // center: [119.01376,32.688719], //中心点
          center: [118.004542,32.779366], //中心点
        },
        animation: false,
        series: []
      });

      let itemArr=[];
      let coordArr=[];
      this.coordList.forEach( item => {
        let coodrListArr=[];
        if(item.gridOfficeCordinate){
          if(item.gridOfficeCordinate.split('%').length>1){
            item.gridOfficeCordinate.split('%').forEach( e => {
              let obj={
                id:item.id,eles:e.split(',')
              }
              itemArr.push(obj) ;
            })
          }else {
            let obj={
              id:item.id,eles:item.gridOfficeCordinate.split(',')
            }
            itemArr.push(obj) ;
          }
        };
        if(item.pointPosition){
          if(item.pointPosition.split('%').length>1){
            item.pointPosition.split('%').forEach( e => {
              // console.log(e);
              let obj = {
                color:item.gridColour,
                arr:e,
                id:item.id
              }
              coordArr.push(obj)
            })
          }else {
            // console.log(item.pointPosition);
            let obj = {
              color:item.gridColour,
              arr:item.pointPosition,
              id:item.id
            }
            coordArr.push(obj)
          }
        };

      })
      console.log(itemArr);
      console.log(coordArr);
      // let arr2 =[
      //   [116.841022,32.629936],[116.843329,32.631137],[116.841365,32.632547],[116.842508,32.633238],
      //   [116.84431,32.633301],[116.843935,32.634431],[116.844697,32.63551],
      //   [116.843398,32.635307],[116.842368,32.635041],[116.841467,32.635176],
      //   [116.840416,32.63477]
      // ];
      let arr2 =itemArr;
      //添加点标记
      var cluster,
              markers = [];
      var points = [

      ];
      arr2.forEach(ele=>{
        points.push({ lnglat: ele.eles })
      })
      //创建所有的点标记
      for (var i = 0; i < points.length; i += 1) {
        let m = new AMap.Marker({
          position: points[i]["lnglat"],
          content:
                  '<div style="background-color: hsla(0, 100%, 50%, 0.7); height: 18px; width: 18px; border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 1px;"></div>',
          offset: new AMap.Pixel(-10, -10)
        });
        markers.push(m);
        let _this = this;
        let _id=arr2[i].id;
        //给点标记添加click事件
        m.on("click", function(e) {
          console.log(e);
          _this.$emit("cks", _id);
        });
      }

      // map.plugin(["AMap.MarkerClusterer"], function() {
      //   cluster = new AMap.MarkerClusterer(map, markers, { gridSize: 30 });
      //   map.setFitView();
      // });
      //上面的部分是echarts的配置，需要注意的是amap，这里的配置就是针对 高德地图 的配置了，而支持哪些配置
      //可以去高德地图的开发平台去查看

      var map = myChart
              .getModel()
              .getComponent("amap")
              .getAMap();
      var layer = myChart
              .getModel()
              .getComponent("amap")
              .getLayer();
      //1
      map.add(markers);
      coordArr.forEach( item => {
       let polygonArr=[];

          item.arr.split(',').forEach(es => {
            polygonArr.push(es.split(':')) ;
          })

        var polygon = new AMap.Polygon({
          map: map,
          path: polygonArr, //设置多边形边界路径
          strokeColor: "#"+ item.color, //线颜色
          strokeOpacity: 0.2, //线透明度
          strokeWeight: 3, //线宽
          fillColor: "#"+ item.color, //填充色
          fillOpacity: 0.2, //填充透明度
          extData: {
            name: "治东社区",
            address: "安徽省淮南市治东社区第五网格",
            tel: "0556-1231231"
          }
        });
        //点击事件
        polygon.on("click", function(e) {
          that.$emit("setOrgId", item.id);
        });
        //变色
        polygon.on("mouseover", function() {
          this.setOptions({
            strokeOpacity: 0.8, //线透明度
            strokeWeight: 5, //线宽
            fillOpacity: 0.5 //填充透明度
          });
        });
        polygon.on("mouseout", function() {
          this.setOptions({
            strokeOpacity: 0.2, //线透明度
            strokeWeight: 3, //线宽
            fillOpacity: 0.35 //填充透明度
          });
        });
      })
      var series = [

      ];

      arr2.forEach(ele=>{
        series.push( {
                  name: "2",
                  coordinateSystem: "amap",
                  type: "lines",
                  zlevel: 1,
                  effect: {
                    show: true,
                    period: 6,
                    trailLength: 0.7,
                    color: "#fff",
                    symbolSize: 3
                  },
                  lineStyle: {
                    normal: {
                      color: "#a6c84c",
                      width: 0,
                      curveness: 0.2
                    }
                  },
                  data: [
                    {
                      fromName: "上海",
                      toName: "包头",
                      coords: [
                        ele.eles,
                        [118.004542,32.779366]
                      ],
                      value: 95
                    }
                  ]
                },
                {
                  name: "上海 Top10",
                  coordinateSystem: "amap",
                  type: "lines",
                  zlevel: 2,
                  effect: {
                    show: true,
                    period: 6,
                    trailLength: 0,
                    symbol: planePath,
                    symbolSize: 15
                  },
                  symbol: ["none", "arrow"],
                  symbolSize: 10,
                  lineStyle: {
                    normal: {
                      color: "#a6c84c",
                      width: 1,
                      opacity: 0.6,
                      curveness: 0.2
                    }
                  },
                  data: [
                    {
                      fromName: "上海",
                      toName: "包头",
                      coords: [
                        ele.eles,
                        [118.004542,32.779366]
                      ],
                      value: 95
                    }
                  ]
                },
                {
                  name: "上海 Top10",
                  type: "effectScatter",
                  coordinateSystem: "amap",
                  zlevel: 2,
                  rippleEffect: {
                    brushType: "stroke"
                  },
                  label: {
                    normal: {
                      show: true,
                      position: "bottom",
                      formatter: "{b}"
                    }
                  },
                  itemStyle: {
                    normal: {
                      color: "#a6c84c"
                    }
                  },
                  data: [
                    {
                      name: "社区服务中心",
                      value: [118.004542,32.779366]
                    }
                  ]
                },)
      })

      myChart.setOption({
        series: series
      });

      //下面是确保高德地图渲染的时候，echarts同时也需要再次渲染一次，保持位置的同步
      layer.render = function() {
        // let series = myChart.getOption().seriesIndexes;
        // myChart.setOption({
        //     series: []
        // });
        myChart.setOption({
          series: series
        });
      };
    }
  }
};
</script>

<style scoped>
</style>
